<template>
  <v-icon
    v-if="props.cloneAction"
    color="grey"
    size="large"
    :data-cy="props.dataCy + '-embedded-clone'"
    @click="props.cloneAction()">
    mdi-plus
  </v-icon>

  <v-icon
    v-if="props.editAction"
    color="grey"
    size="large"
    :data-cy="props.dataCy + '-embedded-edit'"
    @click="props.editAction()">
    mdi-pencil-outline
  </v-icon>

  <v-icon
    v-if="props.deleteAction"
    color="grey"
    size="large"
    :data-cy="props.dataCy + '-embedded-delete'"
    @click="deleteWithConfirmation()">
    mdi-delete-outline
  </v-icon>
</template>

<script setup>
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { useTranslation } from "i18next-vue";

const props = defineProps({
  editAction: {
    type: Function,
    required: false
  },
  cloneAction: {
    type: Function,
    required: false
  },
  deleteAction: {
    type: Function,
    required: false
  },
  dataCy: {
    type: String,
    required: false
  },
  deleteDisabled: {
    type: Boolean,
    default: false
  },
  deleteDisabledCallback: {
    type: Function,
    required: false
  }
});

const { t } = useTranslation();
const createConfirm = useConfirm();
const createSnackbar = useSnackbar();

const deleteWithConfirmation = () => {
  if (props.deleteDisabled) {
    return props.deleteDisabledCallback();
  }

  createConfirm({
    dialogProps: { width: 400 },
    cardProps: { color: "error" },
    title: t("actions.confirmation.delete.title"),
    content: t("actions.confirmation.delete.content"),
    confirmationText: t("actions.confirmation.delete.confirm"),
    cancellationText: t("actions.confirmation.delete.cancel"),
    confirmationButtonProps: { color: "warning" }
  }).then((confirm) => {
    if (confirm) {
      props.deleteAction();
      createSnackbar({
        text: t("actions.deleted"),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 1000 }
      });
    }
  });
};
</script>
